
import "../Foundation/stylable/colors.st.css.js";

import "../Foundation/stylable/easing.st.css.js";
import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_223_0_Loader";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_223_0_Loader__root","statusIndicator":"wds_1_223_0_Loader__statusIndicator","arcsContainer":"wds_1_223_0_Loader__arcsContainer","darkArc":"wds_1_223_0_Loader__darkArc","lightArc":"wds_1_223_0_Loader__lightArc","text":"wds_1_223_0_Loader__text"};
export var keyframes = {"rotation":"wds_1_223_0_Loader__rotation","staggered-rotation":"wds_1_223_0_Loader__staggered-rotation"}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {"wds-loader-fill-loading":"--wds-loader-fill-loading","wds-loader-fill":"--wds-loader-fill","wds-loader-fill-light":"--wds-loader-fill-light","wds-loader-fill-error":"--wds-loader-fill-error","wds-loader-fill-success":"--wds-loader-fill-success"}; 




